export const LogoutIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden>
    <path d="M5.3 20.5c-.5 0-.92-.18-1.27-.52a1.74 1.74 0 0 1-.53-1.29V5.31c0-.5.17-.93.53-1.28.34-.36.77-.53 1.28-.53H12V5H5.3a.3.3 0 0 0-.21.1.3.3 0 0 0-.1.2v13.4c0 .07.03.14.1.2.06.07.13.1.2.1H12v1.5H5.3Zm10.93-4.23-1.04-1.09 2.44-2.43H9.1v-1.5h8.53l-2.44-2.43 1.04-1.09L20.5 12l-4.27 4.27Z" />
  </svg>
);
